export const AutoSaveSection = (props) => {
    const headline = props.headline;
    const subHeading = props.subHeading;
    const image = props.image;
    return (<section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>{subHeading}</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                          <img src={image} alt={headline} />
                      </div>
                      <div className="col-lg-8 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"}}>{subHeading}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
    
    );
}

export default AutoSaveSection;